import type { LeadType } from '@/types'

export type LeadPayload = {
    type: LeadType
    name: string
    email: string
    phone?: string
    message?: string
    listingId?: string
    agentId?: string
    tourDate?: string
    tourTime?: string
    tourKind?: string
    propertyAddress?: string
    propertyType?: string
    bedrooms?: number
    bathrooms?: number
    timeline?: string
    website?: string
}

export type LeadResult = { ok: true } | { ok: false, message: string }

/* Sends any of the site's forms to /api/leads and returns a message that is safe to show. */
export const submitLead = async (payload: LeadPayload): Promise<LeadResult> => {
    try {
        const response = await fetch('/api/leads', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify(payload)
        })

        const data = await response.json().catch(() => null) as { message?: string } | null

        if (response.ok) return { ok: true }

        return { ok: false, message: data?.message || 'Something went wrong. Please try again.' }
    }
    catch {
        return { ok: false, message: 'We could not reach the server. Check your connection and try again.' }
    }
}
